import React from 'react';
import { Link } from 'react-router-dom';

export default function WebsiteFooter() {
  return (
    <footer className="bg-[#080C14] border-t border-white/5" data-testid="website-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <img src="/sidebar-icon.png" alt="" className="h-9 w-9 rounded-md" />
              <span className="text-white font-bold text-xl" style={{ fontFamily: 'Outfit, sans-serif' }}>
                ProjectBook Pro<sup className="text-[10px]">TM</sup>
              </span>
            </div>
            <p className="text-slate-500 text-sm leading-relaxed max-w-sm" style={{ fontFamily: 'Manrope, sans-serif' }}>
              The all-in-one Project ERP & Control System for construction companies. Plan, execute, and deliver projects with confidence.
            </p>
            <p className="text-xs text-slate-600 mt-4" style={{ fontFamily: 'Manrope, sans-serif' }}>
              PLAN &middot; BUILD &middot; DELIVER
            </p>
          </div>

          <div>
            <h4 className="text-xs font-bold tracking-[0.15em] uppercase text-slate-500 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>Product</h4>
            <div className="space-y-2.5">
              <Link to="/website/features" className="block text-sm text-slate-400 hover:text-white transition-colors">Features</Link>
              <Link to="/website/modules" className="block text-sm text-slate-400 hover:text-white transition-colors">Modules</Link>
              <Link to="/demo" className="block text-sm text-slate-400 hover:text-white transition-colors">Try Demo</Link>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-bold tracking-[0.15em] uppercase text-slate-500 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>Contact</h4>
            <div className="space-y-2.5 text-sm text-slate-400" style={{ fontFamily: 'Manrope, sans-serif' }}>
              <p><a href="mailto:info@sgkapps.com" className="hover:text-white transition-colors">info@sgkapps.com</a></p>
              <p><a href="/website" className="hover:text-white transition-colors">www.projectbookpro.com</a></p>
            </div>
          </div>
        </div>

        <div className="border-t border-white/5 mt-12 pt-8 flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-xs text-slate-600" style={{ fontFamily: 'Manrope, sans-serif' }}>
            &copy; {new Date().getFullYear()} ProjectBook Pro&trade;. All rights reserved.
          </p>
          <p className="text-xs text-slate-600" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Developed by <a href="https://www.sgkapps.com" target="_blank" rel="noopener noreferrer" className="text-slate-500 font-medium hover:text-white transition-colors">SGK Apps</a> &middot; A product of VRV Technical & Technology Solutions FZ LLC
          </p>
        </div>
      </div>
    </footer>
  );
}
